// import React from "react";
// import FlxGrid from "../../../../../_src_shared/components/layout/FlxGrid";
// import { isNil, size } from "lodash";
// import { Card, Link } from "@mui/material";
// import Txt from "../../../../../components/typography/Txt";
// import Flx from "../../../../../components/layout/Flx";
// import { ChevronRight, KeyboardArrowRightOutlined } from "@mui/icons-material";
// import { getUserFullNameFromEmail } from "../../../../../utils/functions/getUserFullNameFromEmail";
// import { formatDateTime } from "../../../../../_src_shared/utils/functions/formatDateTime";
// import { blue } from "@mui/material/colors";

// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

// const TemplateSelector = ({ templates, activeTemplate, onSelect }) => {
//   const users = useSelector((state) => state?.users);
//   const loanDrilldown = useSelector((state) => state.loanDrilldown);
//   const navigate = useNavigate();

//   const handleOnReturn = () => {
//     navigate(`/loan/${loanDrilldown?.loanNumber}/communication`);
//     if (onSelect) {
//       onSelect(null);
//     }
//   };
//   if (!isNil(activeTemplate)) {
//     return (
//       <Flx ac gap={0.8} wrap>
//         <Link
//           onClick={handleOnReturn}
//           sx={{
//             fontSize: "12px",
//             cursor: "pointer",
//             fontFamily: "var(--ibm)",
//           }}
//         >
//           Email Templates
//         </Link>
//         <ChevronRight sx={{ fontSize: "16px" }} />
//         <Link
//           sx={{
//             fontSize: "12px",
//             cursor: "pointer",
//             fontFamily: "var(--ibm)",
//           }}
//         >
//           {activeTemplate?.templateName}
//         </Link>
//       </Flx>
//     );
//   }
//   return (
//     <FlxGrid
//       width="320px"
//       grow={size(templates) >= 2 ? 1 : 0}
//       gap={1}
//       sx={{ mt: 2 }}
//     >
//       {templates?.map((template, index) => {
//         return (
//           <Card
//             key={index}
//             variant="outline"
//             onClick={() => onSelect(template)}
//             sx={{
//               p: 2,
//               mb: 2,
//               boxShadow: "none",
//               cursor: "pointer",
//               backgroundColor:
//                 activeTemplate?.templateName === template?.templateName
//                   ? "#e3f2fd35"
//                   : "inherit",
//               border:
//                 activeTemplate?.templateName === template?.templateName
//                   ? `1px solid ${blue[200]}`
//                   : "1px solid #dddddd",
//             }}
//           >
//             <Flx fw jb ac>
//               <Flx column>
//                 <Txt sx={{ fontWeight: 600 }}>{template?.templateName}</Txt>
//                 <Txt secondary>{template?.templateDescription}</Txt>

//                 <Flx column gap={0.5} sx={{ mt: 1 }}>
//                   {template?.createdDate && (
//                     <TemplateMetaItem label={"Created Date:"}>
//                       {formatDateTime(template?.createdDate)}
//                     </TemplateMetaItem>
//                   )}
//                   {template?.createdBy && (
//                     <TemplateMetaItem label={"Created By:"}>
//                       {getUserFullNameFromEmail(users, template?.createdBy)}
//                     </TemplateMetaItem>
//                   )}
//                   {template?.updatedDate && (
//                     <TemplateMetaItem label={"Last Updated:"}>
//                       {formatDateTime(template?.updatedDate)}
//                     </TemplateMetaItem>
//                   )}
//                   {template?.updatedBy && (
//                     <TemplateMetaItem label={"Last Updated By:"}>
//                       {getUserFullNameFromEmail(users, template?.updatedBy)}
//                     </TemplateMetaItem>
//                   )}
//                 </Flx>
//               </Flx>
//               <KeyboardArrowRightOutlined />
//             </Flx>
//           </Card>
//         );
//       })}
//     </FlxGrid>
//   );
// };

// const TemplateMetaItem = ({ label, children }) => {
//   return (
//     <Flx ac wrap gap={1}>
//       <Txt secondary>{label}</Txt>
//       <Txt secondary sx={{ fontWeight: 600 }}>
//         {children}
//       </Txt>
//     </Flx>
//   );
// };
// export default TemplateSelector;

// ------------

import { blue, grey } from "@mui/material/colors";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo, useState } from "react";

import AgGridTableWrapper from "../../../../../components/agGrid/AgGridTableWrapper";
import Flx from "../../../../../components/layout/Flx";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../../../../components/inputs/SearchInput";
import { useLoanTermsHook } from "../../../../../hooks/useLoanTermsHook";
import { isNil } from "lodash";
import { ChevronRightRounded } from "@mui/icons-material";

const TemplateSelector = ({
  templates,
  activeRowKeyValue,
  activeRowKeyName = "name",
  onSelect,
  allowSearch = false,
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  // const [templates, setTemplates] = useState(null);
  const navigate = useNavigate();
  const { getEmailTemplateNames, sendEmailTemplate, previewEmailTemplate } =
    useLoanTermsHook();
  const [quickFilter, setQuickFilter] = useState(null);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Template Name",
        field: "template_display_name",
        flex: 1,
        minWidth: 200,
        cellClass: "ag-cell-vertical-center",
        sort: "asc",
        cellStyle: { cursor: "pointer", fontWeight: 600 },
      },
      {
        headerName: "Description",
        field: "description",
        flex: 2,
        hide: true,
        minWidth: 250,
        cellClass: "ag-cell-vertical-center",
        cellStyle: { cursor: "pointer" },
        valueFormatter: (p) => p.value || "—",
      },
      {
        width: 40,
        cellStyle: {
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        cellRenderer: () => {
          return (
            <Flx center sx={{ height: "100%" }}>
              <ChevronRightRounded sx={{ color: grey[600] }} />
            </Flx>
          );
        },
      },
    ],
    [],
  );

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
    }),
    [],
  );

  const getRowId = useCallback(
    (params) => params.data[activeRowKeyName] || params.data.name,
    [activeRowKeyName],
  );

  const getRowStyle = useCallback(
    (params) => {
      if (activeRowKeyValue === params?.data?.[activeRowKeyName]) {
        return {
          backgroundColor: "#e3f2fd63",
          fontWeight: 600,
          borderLeft: `3px solid ${blue[500]}`,
        };
      }
      return null;
    },
    [activeRowKeyValue, activeRowKeyName],
  );

  const handleOnRowClicked = useCallback(
    (params) => {
      onSelect?.(params?.data);
    },
    [onSelect],
  );

  // useEffect(() => {
  //   if (isNil(templates)) {
  //     getEmailTemplateNames({
  //       onSuccessFn: (data) => setTemplates(data || []),
  //     });
  //   }
  // }, []);

  return (
    <Flx column g={1}>
      {allowSearch && (
        <SearchInput value={quickFilter} onChange={(e) => setQuickFilter(e)} />
      )}
      <AgGridTableWrapper
        height="100%"
        compactTable
        suppressMinHeightWhenPopulated={templates}
      >
        <AgGridReact
          rowData={templates}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          getRowId={getRowId}
          getRowStyle={getRowStyle}
          onRowClicked={handleOnRowClicked}
          domLayout="autoHeight"
          tooltipShowDelay={100}
          enableCellTextSelection
        />
      </AgGridTableWrapper>
    </Flx>
  );
};

export default TemplateSelector;
